<section class="comments-panel">
  <h2>{{ 'pages.restaurantAccount.comments.title' | translate }}</h2>

  <form
    *ngIf="canAdd"
    #commentNgForm="ngForm"
    class="comment-form"
    [formGroup]="commentForm"
    (ngSubmit)="submitComment(commentNgForm)"
  >
    <mat-form-field class="comment-form__field">
      <mat-label>{{ 'pages.restaurantAccount.comments.authorName' | translate }}</mat-label>
      <input
        matInput
        appFormInputTrim
        formControlName="authorName"
        [maxlength]="authorNameMaxLength"
        autocomplete="off"
      >
      <mat-hint align="end">
        {{ commentForm.get('authorName')?.value?.length || 0 }}/{{ authorNameMaxLength }}
      </mat-hint>
      <mat-error *ngIf="commentForm.get('authorName')?.hasError('required') || commentForm.get('authorName')?.hasError('whitespace')">
        {{ 'pages.restaurantAccount.comments.authorNameRequired' | translate }}
      </mat-error>
      <mat-error *ngIf="commentForm.get('authorName')?.hasError('maxlength')">
        {{ 'pages.restaurantAccount.comments.authorNameMaxLength' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field class="comment-form__field">
      <mat-label>{{ 'pages.restaurantAccount.comments.body' | translate }}</mat-label>
      <textarea
        matInput
        appFormInputTrim
        formControlName="body"
        rows="4"
        [maxlength]="bodyMaxLength"
      ></textarea>
      <mat-hint align="end">
        {{ commentForm.get('body')?.value?.length || 0 }}/{{ bodyMaxLength }}
      </mat-hint>
      <mat-error *ngIf="commentForm.get('body')?.hasError('required') || commentForm.get('body')?.hasError('whitespace')">
        {{ 'pages.restaurantAccount.comments.bodyRequired' | translate }}
      </mat-error>
      <mat-error *ngIf="commentForm.get('body')?.hasError('maxlength')">
        {{ 'pages.restaurantAccount.comments.bodyMaxLength' | translate }}
      </mat-error>
    </mat-form-field>

    <div *ngIf="submitError" class="comments-error" role="alert">
      {{ submitError }}
    </div>

    <button
      class="btn btn__primary comment-form__submit"
      type="submit"
      [disabled]="commentForm.invalid || submitting || confirmingPublication"
    >
      <mat-spinner *ngIf="submitting" class="mat-secondary" [diameter]="18"></mat-spinner>
      <span>{{ 'pages.restaurantAccount.comments.send' | translate }}</span>
    </button>
  </form>

  <div class="comments-list" [class.comments-list--readonly]="!canAdd">
    <div *ngIf="loading" class="comments-state">
      <mat-spinner [diameter]="32"></mat-spinner>
      <span>{{ 'pages.restaurantAccount.comments.loading' | translate }}</span>
    </div>

    <div *ngIf="!loading && loadError" class="comments-state comments-error" role="alert">
      {{ loadError }}
    </div>

    <div *ngIf="!loading && !loadError && comments.length === 0" class="comments-state">
      {{ 'pages.restaurantAccount.comments.empty' | translate }}
    </div>

    <ng-container *ngIf="!loading && !loadError">
      <article *ngFor="let comment of comments; trackBy: trackByCommentId" class="comment">
        <header class="comment__header">
          <strong class="comment__author">{{ comment.authorName }}</strong>
          <time class="comment__date" [attr.datetime]="comment.createdAt">
            {{ comment.createdAt | date: 'medium' }}
          </time>
        </header>
        <p class="comment__body">{{ comment.body }}</p>
      </article>
    </ng-container>
  </div>
</section>
